export const primary = {
	main: '#00b0ff'
};
export const danger = {
	main: '#DD2A2C',
	hover: '#CB4331'
};
export const link = {
	main: '#3a5e77',
	hover: '#5487ab'
};
export const secondary = {
	main: '#eeeeee',
	hover: '#FFF'
};
export const background = {
	paper: '#1A1B1C'
};
export const dialog = {
	paper: '#363636'
};
export const success = {
	main: '#4caf50'
};
